import { UrlMatcher, UrlMatchResult, UrlSegment } from '@angular/router';
import { KnownComponentsNames } from '@core/components-names';
import { FeatureToggle } from '@shared/enums';
import { isFeatureToggleActive } from 'app/featuresToggleSettings/feature-toggle-storage';
import { STANDARD_REMOTE_URL_PREFIX } from '../consts';

export const matchAohsRalUrl: UrlMatcher = (url: UrlSegment[]): UrlMatchResult | null => {
	if (url[0]?.path !== STANDARD_REMOTE_URL_PREFIX || url[1]?.path !== KnownComponentsNames.AohsComponent) {
		return null;
	}
	return isFeatureToggleActive(FeatureToggle.EnableAohsRAL)
		? { consumed: url, posParams: { appId: url[1] } }
		: null;
};
